import config from '../../config/config';

export const REFUND_FAILURE = 'REFUND/REFUND_FAILURE';
export const REFUND_LOAD = 'REFUND/REFUND_LOAD';
export const REFUND_SUCCESS = 'REFUND/REFUND_SUCCESS';

export function refundTransaction(transactionId, amountToRefund, refundReason) {
    return {
        failureActionTypeOrCreator: createRefundTransactionFailureActionCreator(transactionId),
        fetchParams: {
            body: {
                amountToRefund: amountToRefund,
                id: transactionId,
                refundReason
            },
            method: 'POST',
            shouldAllowConcurrentFetches: true,
            url: `${config.transactionsApiUrl}/refund`
        },
        loadActionTypeOrCreator: createRefundTransactionLoadActionCreator(transactionId),
        successActionTypeOrCreator: createRefundTransactionSuccessActionCreator(transactionId)
    };
}

export function createRefundTransactionLoadActionCreator(id) {
    return () => ({
        id,
        type: REFUND_LOAD
    });
}

export function createRefundTransactionFailureActionCreator(id) {
    return (error) => ({
        error,
        id,
        type: REFUND_FAILURE
    });
}

export function createRefundTransactionSuccessActionCreator(id) {
    return () => ({
        id,
        type: REFUND_SUCCESS
    });
}
